module.exports = function (form) {
    return function (values, $formContainer, followUpUrl) {
        var wistiaChannelId = $formContainer.data('wistiaChannelId');

        if (wistiaChannelId) {
            var wistiaSubmitFunction = ICF.Modules.Wistia.WistiaFormSubmit(form);
            wistiaSubmitFunction(values, $formContainer, followUpUrl);
        }

        $formContainer.find('.embedded-subscription-module__text').remove();
        $formContainer.find('.marketo-form').remove();

        var $thankYouContainer = $formContainer.find('.embedded-subscription-module__thank-you');
        $thankYouContainer.addClass('embedded-subscription-module__thank-you--active');

        return false;
    };
};